import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageToggle from "./LanguageToggle";
import "../assets/TopicPage.css";

// Banner (2026-10-22): the study name on the left, aligned with the page's
// content column (same 800 px column and 20 px gutter as the numbered steps
// below); one Georgetown-blue button on the right that opens the consent
// form and, while on it, returns to the main page; next to it the language
// dropdown (no icon).
const SiteHeader = () => {
    const { t } = useTranslation();
    const onConsent = useLocation().pathname.startsWith("/consent");
    return (
        <header className="site-header">
            <div className="site-header__inner">
                <Link to="/" className="site-header__title-link" aria-label={t("common.appTitle")}>
                    <h1 className="site-header__title">{t("common.appTitle")}</h1>
                </Link>
                <nav className="site-header__nav" aria-label={t("common.nav.label")}>
                    <Link to={onConsent ? "/" : "/consent"} className={"gu-button" + (onConsent ? " gu-button--active" : "")}>
                        {onConsent ? t("common.nav.home") : t("common.nav.consent")}
                    </Link>
                    <LanguageToggle />
                </nav>
            </div>
        </header>
    );
};

export default SiteHeader;
